import { find } from 'lodash'
import React from 'react'
import PropTypes from 'prop-types'
import moment from 'moment'
import * as graph from '@adc/sdk'
import { Form } from 'semantic-ui-react'
import {
  DropdownField,
  CheckboxField,
  DatePickerField,
  constants,
} from '@adc/ui-adc'
import classnames from 'classnames/bind'
import STATICS from '../../statics'
import styles from './styles.scss'

const cx = classnames.bind(styles)
const { EventType } = graph.enums

const buildOptions = list =>
  [
    {
      key: 'any',
      text: <span className={cx('any-label')}>{STATICS.ANY_LABEL}</span>,
      value: '',
    },
  ].concat(
    list.map(item => ({
      key: item.value,
      text: item.text || item.label,
      value: item.value,
    }))
  )

const stateOptions = buildOptions(constants.optionLists.states)
const productTypeOptions = buildOptions(STATICS.AUCTION_TYPE_LIST)

const buyingTypeOptions = [
  {
    key: 'any',
    text: <span className={cx('any-label')}>{STATICS.ANY_LABEL}</span>,
    value: '',
  },
  {
    key: EventType.LIVE,
    text: 'In-Person',
    value: EventType.LIVE,
  },
  {
    key: EventType.ONLINE,
    text: 'Online',
    value: EventType.ONLINE,
  },
  {
    key: 'direct_offer_enabled',
    text: 'Direct Offer',
    value: 'direct_offer_enabled',
  },
]

const CalendarFilters = ({
  elmId,
  productTypeFilter,
  buyingTypeFilter,
  bidEndDateFilter,
  stateFilter,
  hidePastEventsFilter,
  onChangeHandler,
}) => (
  <div>
    <div className={cx('calendar-filter-container')}>
      <div className={cx('filter-group')}>
        <div
          className={cx('calendar-filter', 'u-mr-2', 'date-filter')}
          data-elm-id={`calendar_${elmId}_filter_by_date`}
        >
          <Form>
            <DatePickerField
              elmId='calendar'
              hideWrapper
              onChange={value => {
                const selectedDate = moment(value)

                // Because we use a text mask here dates can be invalid when
                // a user submits a partial date
                if (!selectedDate.isValid()) {
                  return
                }

                onChangeHandler(
                  'bidEndDateFilter',
                  selectedDate.format(moment.HTML5_FMT.DATE)
                )
              }}
            />
          </Form>
        </div>

        <div
          className={cx('calendar-filter', 'u-mr-2')}
          data-elm-id={`calendar_${elmId}_filter_by_state`}
        >
          <DropdownField
            onChange={value => {
              const valueObj = value ? find(stateOptions, { value }) : null
              onChangeHandler('stateFilter', valueObj)
            }}
            options={stateOptions}
            placeholder={STATICS.SELECT_STATE}
            value={stateFilter ? stateFilter.value : ''}
            elmId={`calendar_${elmId}_filter_by_state`}
          />
        </div>

        <div
          className={cx('calendar-filter', 'u-mr-2')}
          data-elm-id={`calendar_${elmId}_filter_by_product`}
        >
          <DropdownField
            onChange={value => {
              const valueObj = value
                ? find(productTypeOptions, { value })
                : null
              onChangeHandler('productTypeFilter', valueObj)
            }}
            options={productTypeOptions}
            placeholder={STATICS.ASSET_TYPE}
            value={productTypeFilter?.value || ''}
            elmId={`calendar_${elmId}_filter_by_product`}
          />
        </div>

        <div
          className={cx('calendar-filter', 'u-mr-2')}
          data-elm-id={`calendar_${elmId}_filter_by_buying_type`}
        >
          <DropdownField
            onChange={value => {
              const valueObj = value ? find(buyingTypeOptions, { value }) : null
              onChangeHandler('buyingTypeFilter', valueObj)
            }}
            options={buyingTypeOptions}
            placeholder='Buying Type'
            value={buyingTypeFilter?.value || ''}
            elmId={`calendar_${elmId}_filter_by_buying_type`}
          />
        </div>

        <div
          className={cx('calendar-filter', 'checkbox-filter')}
          data-elm-id={`calendar_${elmId}_filter_past_events`}
        >
          <CheckboxField
            checkboxLabel='Hide past events'
            checked={hidePastEventsFilter}
            name='hide_past_events'
            onClick={(e, value) => {
              onChangeHandler('hidePastEventsFilter', value.checked)
            }}
            compact={false}
            elmId={`calendar_${elmId}_filter_past_events`}
          />
        </div>
      </div>
    </div>
  </div>
)

CalendarFilters.propTypes = {
  elmId: PropTypes.string.isRequired,
  onChangeHandler: PropTypes.func.isRequired,
  productTypeFilter: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  buyingTypeFilter: PropTypes.object,
  bidEndDateFilter: PropTypes.object,
  hidePastEventsFilter: PropTypes.bool,
  stateFilter: PropTypes.object,
}

export default CalendarFilters
